// src/layouts/AdminLayout.jsx
import React, { useState, useEffect } from "react";
import { Colors } from "../constants/Colors";
import { Typography } from "../constants/Typography";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Notifications from "../components/Notifications";
import ProfileModal from "../modals/ProfileModal";
import Footer from "../components/Footer";

import "../styles/modal.css";
import "../styles/AdminLayout.css";

const AdminLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("profile");
  const [selectedUser, setSelectedUser] = useState(null);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const toggleSidebar = () => setSidebarOpen((s) => !s);

  const handleOpenModal = (show, content, user) => {
    setShowModal(show);
    setModalContent(content);
    setSelectedUser(user);
  };

  return (
    <div
      className="admin-layout"
      style={{ fontFamily: Typography.FONT_FAMILY }}
    >
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      <div
        className="main-content"
        style={{
          backgroundColor: Colors.LIGHT_GRAY,
          fontFamily: Typography.FONT_FAMILY,
        }}
      >
        <Header
          toggleSidebar={toggleSidebar}
          onOpenModal={handleOpenModal}
          unreadCount={unreadCount}
          setNotificationsOpen={setNotificationsOpen}
        />

        <Notifications
          isOpen={notificationsOpen}
          onClose={() => setNotificationsOpen(false)}
          onOpenModal={handleOpenModal}
          onUnreadCountChange={setUnreadCount}
        />

        <main
          className="content-wrapper p-4"
          style={{ fontFamily: Typography.FONT_FAMILY }}
        >
          {children}
        </main>

        <Footer />

        {showModal && (
          <ProfileModal
            show={showModal}
            onClose={() => handleOpenModal(false, null, null)}
            user={selectedUser || {}}
            isSettings={modalContent === "settings"}
          />
        )}
      </div>
    </div>
  );
};

export default AdminLayout;